import React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';

import MenuItem from 'components/Menu/MenuItem';
import MenuSectionGrid from 'components/Menu/MenuSectionGrid';
import { useHasInvestorDayFeatureFlag } from 'bento-ordering/utils/featureFlags/hasInvestorDayFeatureFlag';

const MenuSectionList = ({
  handleClick,
  menuList,
  shouldLazyLoadMenu,
  isExpanded
}) => {
  const hasInvestorDayFeature = useHasInvestorDayFeatureFlag();

  const renderMenuSectionList = () => (
    <MenuSectionGrid>
      {menuList.map(menuItem => {
        return (
          <MenuSectionListItem
            key={menuItem.id}
            menuItem={menuItem}
            handleClick={handleClick}
            shouldLazyLoadMenu={shouldLazyLoadMenu}
            hasInvestorDayFeature={hasInvestorDayFeature}
          />
        );
      })}
    </MenuSectionGrid>
  );

  return <Collapse in={isExpanded}>{renderMenuSectionList()}</Collapse>;
};

MenuSectionList.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  menuList: PropTypes.array,
  handleClick: PropTypes.func.isRequired,
  shouldLazyLoadMenu: PropTypes.bool
};

const MenuSectionListItem = ({
  menuItem,
  handleClick,
  shouldLazyLoadMenu,
  hasInvestorDayFeature
}) => (
  <MenuItem
    {...menuItem.product}
    id={menuItem.id}
    inventory={menuItem.inventory}
    inventoryLessCart={menuItem.inventoryLessCart}
    handleClick={() => handleClick(menuItem.product.slug)}
    shouldLazyLoadMenu={shouldLazyLoadMenu}
    lowInventoryCount={5}
    hasInvestorDayFeature={hasInvestorDayFeature}
  />
);

MenuSectionListItem.propTypes = {
  menuItem: PropTypes.shape({
    id: PropTypes.number,
    product: PropTypes.object,
    inventory: PropTypes.number,
    inventoryLessCart: PropTypes.number
  }),
  handleClick: PropTypes.func.isRequired,
  shouldLazyLoadMenu: PropTypes.bool,
  hasInvestorDayFeature: PropTypes.bool
};

export default MenuSectionList;
